module.exports = __webpack_public_path__ + "img/payment_scuccessful.3abb863d.png";